export const getFeedTimestampMs = (value) => {
  if (!value) return 0;
  if (typeof value?.seconds === "number") return value.seconds * 1000;
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatFeedTimeAgo = (value) => {
  const timestampMs = getFeedTimestampMs(value);
  if (!timestampMs) return "Recently";

  const diff = Math.max(0, Math.floor((Date.now() - timestampMs) / 1000));

  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  if (diff < 2592000) return `${Math.floor(diff / 604800)}w ago`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)}mo ago`;

  return `${Math.floor(diff / 31536000)}y ago`;
};